import { createSelector } from 'reselect';
import { getModelJson } from 'features/page-model/selectors';

export const getWarningMessage = createSelector(getModelJson, (m) => m?.warningMessage ?? null);
